import {Api} from "./api"

export default class UserGroupApi extends Api {
    constructor() {
        super("/userGroup");
    }

    async getUserGroups() {
        return await this.call("/list_userGroup")
    }

    async addUserGroup(userGroupName: string, userIDS: number[]) {
        return await this.call("/add_userGroup", {userGroupName, userIDS});
    }

    async deleteUserGroup(userGroupID: number) {
        return await this.call("/delete_userGroup", {userGroupID});
    }

    async updateUserGroup(userGroupID: number, userGroupName: string, userIDS: number[]) {
        return await this.call("/update_userGroup", {userGroupID, userGroupName, userIDS});
    }
}